export default __webpack_public_path__ + "static/assets/c1f42703b6047c0687a44232ce49c239.png";